import { FormControl, Grid, InputLabel, StandardTextFieldProps, TextField, Typography } from "@mui/material"

interface KaziTextFieldWithLabelProps extends StandardTextFieldProps {
    fieldLabel: string;
}

export const KaziTextFieldWithLabel = ( props: KaziTextFieldWithLabelProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'} width={'100%'} flex={1}>        
            <Typography variant='body-small' color={'black.200'} marginBottom={1}>{props.fieldLabel}</Typography>  
            <FormControl>   
                <InputLabel >{props.value || props.placeholder ?"":props.fieldLabel}</InputLabel>
                <TextField 
                    {...props}
                />
            </FormControl>   
        </Grid>
    )
}